var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 52,
    viewBox: "0 0 43 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4378 25.91L41.4316 25.9415L41.4274 25.9733L41.4121 26.0894C40.537 32.7364 35.5353 38.962 29.9311 43.8582C27.2204 46.2265 24.5588 48.1188 22.5715 49.4191C22.2094 49.656 21.8709 49.8725 21.5599 50.0679C21.4151 49.9769 21.2643 49.8813 21.1079 49.7812L20.5689 50.6235L21.1079 49.7812C19.4461 48.7177 17.1778 47.1589 14.7657 45.1896C9.82308 41.1542 4.79768 35.8131 2.64997 29.8849L2.62219 29.8082L2.61455 29.7871L2.60597 29.7664L2.5748 29.691L1.80826 30.0083L2.57479 29.691C1.56194 27.244 1 24.5534 1 21.7183C1 10.2957 10.1564 1.05457 21.4286 1.05457C32.7007 1.05457 41.8571 10.2957 41.8571 21.7183C41.8571 23.1181 41.7202 24.4809 41.4605 25.7952L41.4378 25.91Z",
    fill: "#73FF8A",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6 25.0761C20.6928 25.0761 23.2 21.925 23.2 18.038C23.2 14.151 20.6928 11 17.6 11C14.5072 11 12 14.151 12 18.038C12 21.925 14.5072 25.0761 17.6 25.0761Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.6736,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4 25.0761C30.4928 25.0761 33 21.925 33 18.038C33 14.151 30.4928 11 27.4 11C24.3072 11 21.8 14.151 21.8 18.038C21.8 21.925 24.3072 25.0761 27.4 25.0761Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.6736,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0454 23.6685C26.8379 23.6685 28.2909 21.1476 28.2909 18.038C28.2909 14.9284 26.8379 12.4076 25.0454 12.4076C23.253 12.4076 21.8 14.9284 21.8 18.038C21.8 21.1476 23.253 23.6685 25.0454 23.6685Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7545 23.6685C17.547 23.6685 19 21.1476 19 18.038C19 14.9284 17.547 12.4076 15.7545 12.4076C13.9621 12.4076 12.5091 14.9284 12.5091 18.038C12.5091 21.1476 13.9621 23.6685 15.7545 23.6685Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7273 34.6734C18.3636 34.6734 16.3273 31.4743 15.7545 29.5548",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2182 27.6353C17.2182 27.6353 15.8182 30.1946 12 30.1946",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.5165de5aa013ca8f2e9da3fb5d9d3a7f.svg";
export { ForwardRef as ReactComponent };